export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook("app:error", (error) => {
    const { clear } = useAuth();

    if (error.statusCode === 401 && error.data?.clearAuth) {
      clear();
      if (import.meta.client) {
        window.location.href = error.data.redirectTo;
      }
    }
  });
});
